
import React, {Component} from 'react';
import axios from 'axios';
import {ToastContainer, ToastStore} from 'react-toasts';

import {SERVER_URL}  from '../Constants';



class PrintReceipt extends Component {
  constructor(props) {
    super(props);

    this.state = {
        srId:'',
        name: '',
        serviceFee:0,
        shippingAddress: '',
        shippingAddress2: '',
        shippingCity: '',
        shippingState: '',
        shippingPostalCode: '',
        shippingCountry: '',
        shippingPhone: '',
        mainPhone:'',
        base64Icon: '',
        billingAddress: '',
        recipient:'',
        dateReceived:'',
        barcodeValue:'',
        storageLocation:'',
        loading:true,
        parcelRef:'',
        parcelGroupTotalCount: 0,
        parcelGroupNum: 0,
        picUrl:'',
        signUrl:'',
        roomNumber:'',
        arrivalDate:'',

    };
  }

  async componentDidMount() {
    
    console.log('print id=' + this.props);
    var id = '';
    var token = '';
    var vid = '';

    if (this.props.match.params.id){
        var params = this.props.match.params.id.split('&');
        id= params[0];
        token= params[1].split('=')[1];
        vid= params[2].split('=')[1];
    }else{
      return (
        <div> Invalid ID </div>
      );
    }
      // Load the SRITem from the server
      let srItem = (await axios.get(`${SERVER_URL}/SR/${id}`, {headers: { 'Authorization': `Bearer ${token}` }})).data;
      let venue = (await axios.get(`${SERVER_URL}/venue/${vid}`, {headers: { 'Authorization': `Bearer ${token}` }})).data;
  
      //console.log(srItem);
      if (srItem===undefined || venue===undefined){
          return( <div> Item ID or login not valid to load this invoice. </div>);
      }

      this.setState({
          srId: srItem.id,
          recipient:srItem.recipient,
          dateReceived:srItem.dateReceived,
        name: venue.name,
        active:venue.active,
        publishId:venue.publishId,
        venueDescription:venue.venueDescription,
        shippingAddress: venue.shippingAddress,
        shippingAddress2: venue.shippingAddress2,
        shippingCity: venue.shippingCity,
        shippingState: venue.shippingState,
        shippingPostalCode: venue.shippingPostalCode,
        shippingCountry: venue.shippingCountry,
        shippingPhone: venue.shippingPhone,
        mainPhone:venue.mainPhone,
        base64Icon: venue.base64Icon,
        billingAddress: venue.billingAddress,
        serviceFee: srItem.serviceFee,
        barcodeValue:srItem.barcodeValue,
        storageLocation:srItem.storageLocation,
        parcelRef:srItem.parcelRef,
        parcelGroupTotalCount: srItem.parcelGroupTotalCount,
        parcelGroupNum:srItem.parcelGroupNum,
        picUrl: (srItem.picUrl==='') ? '../default-placeholder.png' : srItem.picUrl, 
        signUrl: (srItem.signUrl==='') ? undefined : srItem.signUrl,
        arrivalDate: srItem.arrivalDate,
        roomNumber:srItem.roomNumber,
        parcelSize:srItem.parcelSize,
      });


  }
  handleDismiss=()=> {
    this.setState({ showAlert: false });
  }
  renderToast=()=>{
    return <div>
        
        <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
    </div>
}
trimBarcode=(barcodeStr)=>{
    if (barcodeStr){
      try{
        let length = 25
       if (barcodeStr.length > 25){
         return barcodeStr.substring(0,length) + '...';
       }else{
         return barcodeStr;
       }
      }catch(e){
        return '';
      }
    }else{
      return '';
    }
  }

   formatDateTime=(d)=>{
    try {
        if (d){
            var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
            let cellDate = new Date(d);
            return cellDate.toLocaleDateString([],options) +  ' at ' + cellDate.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
        }else{
            return  '';
        }
    }catch(e){
        return  '';

    }
  }
  formatDate=(d)=>{
    try {
        if (d){
            var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
            let cellDate = new Date(d);
            return cellDate.toLocaleDateString([],options) ;
        }else{
            return  '';
        }
    }catch(e){
        return  '';

    }
  }

  formatMoney=(number)=> {
      try{
        return number.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      }catch(e){
        return 'NA';
      }
    
  }
  render() {
    if (this.state.srId===''){
        return (
        
            <div className="container text-center">
           
            <br/>
            <h3 className='text-info'>Loading ...</h3>
      
            </div>
             
          )
    }
   else{

    return (

    
        <div style={{margin:'0px'}}>
        
         <div className='row text-center'>
            <div className='col text-center'> 
               <img style={{width: '200px', height:'200px'}} src={this.state.base64Icon} alt=''/> 
               <br/>
                <p className='text-primary' style={{fontSize:18, color:'black'}}>{this.state.name} </p>
                
           </div>
        </div>    
        <br/><br/>
        <div className='row justify-content-md-center'>
            <div className='col-9 text-center'> 
                <p style={{fontSize:18, color:'black', fontWeight:'bold'}}><h3>Package Handling Invoice</h3></p>
                
               
                <hr/>
           </div>
        </div>    
      

                  
        <br/> <br/>
      
        <div className='row justify-content-md-center' >
            <div className='col-9 text-center'> 
                <div>
                    <h3 className='text-muted text-left'>Details</h3>
                    <hr />
                    <br/> <br/>
                    
                    <div className='row text-center'>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'normal'}}>Guest (recipient): </p> </div>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:20, color:'black', fontWeight:'bold'}}>{this.state.recipient}</p> </div>
                    </div>
                    <div className='row text-center'>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'normal'}}>Arrival Date: </p> </div>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'bold'}}>{this.formatDate(this.state.arrivalDate)}</p> </div>
                    </div>
                    <div className='row text-center'>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'normal'}}>Room#: </p> </div>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'bold'}}>{(this.state.roomNumber) ? this.state.roomNumber : '---'}</p> </div>
                    </div>

                    <div className='row text-center'>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'normal'}}>Received: </p> </div>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'bold'}}>{this.formatDateTime(this.state.dateReceived)}</p> </div>
                    </div>
                    <div className='row text-center'>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'normal'}}>Tracking#: </p> </div>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:14, color:'black', fontWeight:'bold'}}>{(this.state.barcodeValue) ? this.trimBarcode(this.state.barcodeValue) : '---'}</p> </div>
                    </div>
                    <div className='row text-center'>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'normal'}}>Storage Location#: </p> </div>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'bold'}}>{(this.state.storageLocation) ? this.state.storageLocation : '---'}</p> </div>
                    </div>
                    <div className='row text-center'>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'normal'}}>Reference #: </p> </div>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'bold'}}>{(this.state.parcelRef) ? this.state.parcelRef : '---'}</p> </div>
                    </div>
                    <div className='row text-center'>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'normal'}}>Parcel: </p> </div>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'bold'}}>{this.state.parcelGroupNum} of {this.state.parcelGroupTotalCount}</p> </div>
                    </div>
                    <div className='row text-center'>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'normal'}}>Parcel Size: </p> </div>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'bold'}}>{this.state.parcelSize} </p> </div>
                    </div>
                    <div className='row text-center'>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'normal'}}>Invoice Created: </p> </div>
                        <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'normal'}}>{this.formatDateTime(new Date())}</p> </div>
                    </div>
                </div>
           </div>
          


        </div>    
        <br/> <br/> <br/> <br/>
        <div className='row justify-content-md-center' >
            <div className='col-9 text-center'> 
                <div>
                    <h3 className='text-muted  text-left'>Service Charge Summary</h3>
                    <hr />
                    <br/>
                    
                        <div className='row text-center'>
                            <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'normal'}}>Parcel Handling Fee: </p> </div>
                            <div className='col text-right'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'normal'}}>{this.formatMoney(this.state.serviceFee)}</p> </div>
                        </div>
                        <br/><br/><br/>
                        
                             <div className='row text-center'>
                                <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'bold'}}>Total: </p> </div>
                                <div className='col text-right'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'bold'}}>{this.formatMoney(this.state.serviceFee)}</p> </div>
                            </div>
                            <hr />
                   
                </div>
            </div>
        </div>      
                
       
          <div className='row' style={{bottom:0, left:0,width:'100%',position:'fixed', textAlign:'center' }}>
            <div className='col text-center'> 
                    <p className='text-primary'>ID: {this.state.srId} </p>
   
                    <p className='text-secondary' style={{fontSize:14}}>{this.state.shippingAddress + ' ' + this.state.shippingAddress2 + ' ' + this.state.shippingCity + ' ' + this.state.shippingState + '. ' + this.state.shippingPostalCode +'      tel:' + this.state.mainPhone} </p>
            </div>
         </div>
      </div>

    )
   }
  }
}

export default PrintReceipt;